import { CSSProperties } from 'react'
import cn from 'classnames'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

import { FlexLayout, PageHeader, OptionCard } from 'components'
import { analyticsContext, useValueContext } from 'contexts'
import { defaultColor } from 'consts'
import { DictValue } from 'types'
import { useColor } from 'utils'

import './styles.scss'

export const Status = observer(() => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { taskStore, projectStore } = useValueContext()
  const color = useColor()
  const { config } = projectStore
  const { task, setTaskField } = taskStore

  const onSelect = (status: DictValue) => {
    setTaskField('status', status)
    navigate(-1)
  }

  return (
    <FlexLayout.Container vertical>
      <PageHeader>{t('Статус')}</PageHeader>

      <FlexLayout.Content className="scrollable-list" scrollable>
        {config?.statuses?.map((x: DictValue) => {
          const onClick = () => {
            analyticsContext.trackEvent('status_selected')
            onSelect(x)
          }

          return (
            <OptionCard
              key={x.id}
              className={cn('status-option', { selected: x.id === task?.status?.id })}
              style={{ '--status-background': x[color] || x[defaultColor] } as CSSProperties}
              onClick={onClick}
            >
              {t(x.title)}
            </OptionCard>
          )
        })}
      </FlexLayout.Content>
    </FlexLayout.Container>
  )
})
